export const GET_CERTIFICATE = "GET_CERTIFICATE";
export const GET_ALL_CERTIFICATES_AWARDED = "GET_ALL_CERTIFICATES_AWARDED";
export const RESET_CERTIFICATE_DATA = "RESET_CERTIFICATE_DATA";
export const SET_CERTIFICATES_SELECTOR = "SET_CERTIFICATES_SELECTOR";
export const SET_USER_TO_CERTIFICATE = "SET_USER_TO_CERTIFICATE";
export const GET_CERTIFICATES_BY_USER = "GET_CERTIFICATES_BY_USER";
export const GET_LOGO = "GET_LOGO"; 
export const GET_CERTIFICATE_BY_ID = "GET_CERTIFICATE_BY_ID"; 